import React from 'react';
import type { PatientDetailsPatientProp } from './internal';
import {
  getPatientFullName,
  getValueOrUnknownString,
  PatientDetailsSection
} from './internal';
import { HBox } from '../layout';
import { PersonImage } from '../basic';

/**
 * Component for displaying patient's avatar and his name.
 *
 * @param properties a {@link PatientDetailsPatientProp} object
 * @return the created {@link JSX.Element}.
 * @constructor
 */
export function PatientDetailsAvatarAndName({
  patient,
  ...props
}: Readonly<PatientDetailsPatientProp>): JSX.Element {
  return (
    <PatientDetailsSection
      {...props}
      className="ehs-patient-details-avatar-and-name"
    >
      <HBox className="details">
        <PersonImage
          emptyState="defaultAvatar"
          image={patient.profileImage}
          className="avatar"
        />
        <h3 className="patient-name">
          {getValueOrUnknownString(getPatientFullName(patient))}
        </h3>
      </HBox>
    </PatientDetailsSection>
  );
}
